// листинг в каталоге

import { ref , reactive } from 'vue';
import { createApp , watch } from 'vue/dist/vue.esm-bundler';
import { createPinia } from "pinia";
import { useContextStore } from '../../../../assets/site/js/contextStore.js';
import { clearPhone , clearName , clearEmail , prettyMoney } from '../../../../assets/site/js/lib.js';
import courier from '../../../../assets/site/vue/courier.vue';
import shop from '../../../../assets/site/vue/shop.vue';

function initCheckoutPage(){

    const el = document.querySelector( '#checkout' );

    if( el ){
        createApp(
            {
                components : {
                    courier ,
                    shop
                } ,
                setup(){

                    const contextStore = useContextStore();
                    const user = contextStore.getUser();

                    const user_name = ref( user ? user.name : '' );
                    const user_name_error = ref( true );
                    const user_email = ref( user ? user.email : '' );
                    const user_email_error = ref( true );
                    const user_phone = ref( user ? user.phone : '' );
                    const user_phone_error = ref( true );
                    const comment = ref( '' );
                    const comment_error = ref( true );

                    const delivery_error = ref( true );
                    const payment_error = ref( true );

                    const save_error = ref( '' );

                    const click_order = ref( false );

                    const delivery = reactive(
                        [
                            {
                                id : 'delivery_shop' ,
                                available : [ 'delivery_shop' , 'delivery_courier' , 'payment_offline' ] ,
                                title : 'Самовывоз из магазина van Laack ' ,
                                comment : '' ,
                                type : 'shop' ,
                                address : '' ,
                                active : false ,
                                visible : true ,
                                component : 'shop' ,
                                data : {
                                    address : ''
                                }
                            } ,
                            {
                                id : 'delivery_courier' ,
                                available : [ 'delivery_shop' , 'delivery_courier' , 'payment_offline' , 'payment_card' ] ,
                                title : 'Доставка курьером ' ,
                                comment : '' ,
                                type : 'courier' ,
                                address : '' ,
                                active : false ,
                                visible : true ,
                                component : 'courier' ,
                                data : {
                                    address : ''
                                }
                            }
                        ]
                    );

                    const payment = reactive(
                        [
                            {
                                id : 'payment_offline' ,
                                available : [ 'delivery_shop' , 'delivery_courier' , 'payment_offline' , 'payment_card' ] ,
                                title : 'При получении заказа' ,
                                comment : 'Наличными или банковской картой при получении заказа' ,
                                type : 'offline' ,
                                address : '' ,
                                active : false ,
                                visible : true ,
                                component : '' ,
                                data : {}
                            }
                            ,{
                                id : 'payment_card' ,
                                available : [ 'delivery_courier' , 'payment_offline' , 'payment_card' ] ,
                                title : 'Банковской картой' ,
                                comment : 'Онлайн банковской картой МИР, Visa, Mastercard' ,
                                type : 'card' ,
                                address : '' ,
                                active : false ,
                                visible : true ,
                                component : '' ,
                                data : {}
                            }
                        ]
                    );

                    function updateAvailability( item ){
                        delivery.forEach( delivery_item => {
                                delivery_item.visible = item.available.indexOf( delivery_item.id ) >= 0;
                                if( !delivery_item.visible ){
                                    delivery_item.active = false;
                                }
                            }
                        );
                        payment.forEach( payment_item => {
                                payment_item.visible = item.available.indexOf( payment_item.id ) >= 0;
                                if( !payment_item.visible ){
                                    payment_item.active = false;
                                }
                            }
                        );
                    }

                    function setDeliveryMethod( method ){
                        delivery.forEach( item => item.active = item.type === method.type );
                        updateAvailability( method );
                    }

                    function setPaymentMethod( method ){
                        payment.forEach( item => item.active = item.type === method.type );
                        updateAvailability( method );
                    }

                    function validateEmail( email ){
                        let temp = String( email ).trim();

                        if( !temp ){
                            return 'Поле обязательно к заполнению'
                        }

                        if( !temp.match( /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i ) ){
                            return 'Некорректный email';
                        }

                        return true;
                    }

                    function validateName( name ){
                        let temp = String( name ).trim();

                        if( !temp ){
                            return 'Поле обязательно к заполнению'
                        }

                        if( !temp.match( /^[a-zA-Zа-яёА-ЯЁ\s]+$/i ) ){
                            return 'Допускаются только русские, латинские буквы и пробел';
                        }

                        return true;
                    }

                    function validatePhone( phone ){
                        let temp = String( phone ).trim();

                        if( !temp ){
                            return 'Поле обязательно к заполнению'
                        }

                        const regex = /[^0-9]/gi;
                        temp = temp.replaceAll( regex , '' );

                        if( !temp.match( /^79[0-9]{9}$/i ) ){
                            return 'Ведите 11 цифр , начинаться телефон должен на 79...';
                        }

                        return true;
                    }

                    function validateDelivery(){
                        const delivery_item = delivery.find( i => i.active );
                        if( !delivery_item ){
                            return 'Не выбран тип доставки';
                        }
                        if( !delivery_item?.data?.address ){
                            return 'Не выбран адрес доставки';
                        }
                        return true;
                    }

                    function isOK(){
                        return user_name_error.value === true
                            && user_email_error.value === true
                            && user_phone_error.value === true
                            && payment_error.value === true
                            && delivery_error.value === true;
                    }

                    function gotoId( id ){
                        let access = document.getElementById( id );
                        window.scrollTo( {
                            top : access.scrollTop ,
                            left : access.scrollLeft
                        } );
                    }

                    function gotoError(){
                        if( user_name_error.value !== true ){
                            gotoId( 'user_name_point' );
                        }else if( user_phone_error.value !== true ){
                            gotoId( 'user_phone_point' );
                        }else if( user_email_error.value !== true ){
                            gotoId( 'user_email_point' );
                        }else if( delivery_error.value !== true ){
                            gotoId( 'delivery_point' );
                        }else if( payment_error.value !== true ){
                            gotoId( 'payment_point' );
                        }
                    }

                    function validatePayment(){
                        const payment_item = payment.find( i => i.active );
                        if( !payment_item ){
                            return 'Не выбран тип оплаты';
                        }
                        return true;
                    }

                    function validate(){

                        user_name_error.value = validateName( user_name.value );
                        user_email_error.value = validateEmail( user_email.value );
                        user_phone_error.value = validatePhone( user_phone.value );
                        delivery_error.value = validateDelivery();
                        payment_error.value = validatePayment();

                        return isOK();
                    }

                    async function send(){

                        click_order.value = true;

                        if( !validate() ){
                            gotoError();
                            return;
                        }

                        try{

                            let answer = await contextStore.sendOrder(
                                {
                                    name : user_name.value ,
                                    email : user_email.value ,
                                    phone : user_phone.value ,
                                    comment : comment.value ,
                                    delivery ,
                                    payment
                                }
                            );

                            window.dataLayer = window.dataLayer || [];
                            save_error.value = '';

                            if( answer.error ){
                                save_error.value = answer.error;
                                console.log( answer.error );
                                dataLayer.push( { "event" : "create_order_error" , "message" : answer.error } );
                            }else if( answer.url ){
                                dataLayer.push(
                                    {
                                        "event" : "purchase" ,
                                        'eventCallback' : ( id ) => {
                                            if( id.startsWith( "GTM-" ) ){
                                                document.location = answer.url;
                                            }
                                        }
                                    }
                                );
                            }

                        }catch( e ){
                            console.log( e.message );
                        }

                    }

                    function hasUniqueValue( parameter ){
                        return parameter.values.find( item => item.is_unique );
                    }

                    function getTotal(){
                        return contextStore.getBasket().items.reduce( ( total , currentValue ) => accumulator + currentValue , 0 );
                    }

                    return {
                        user_name ,
                        user_name_error ,
                        user_email ,
                        user_email_error ,
                        user_phone ,
                        user_phone_error ,
                        comment ,
                        comment_error ,

                        save_error ,

                        contextStore ,

                        setDeliveryMethod ,
                        delivery ,

                        setPaymentMethod ,
                        payment ,

                        validate ,
                        isOK ,
                        click_order ,
                        send ,

                        prettyMoney ,
                        hasUniqueValue ,

                        delivery_error ,
                        payment_error

                    }
                }
            }
        )
            .use( createPinia() )
            .mount( el )
    }


}

document.addEventListener( "DOMContentLoaded" , initCheckoutPage );
